import "./CommercialLicenseWidget.css";
import { getUserCommercialLicense } from "../../shared/api/getUserCommercialLicense";

export const CommercialLicenseWidget = {
  data() {
    return {
      isLoading: false,
      isError: false,
      errorType: "",
      errorMessage: "",
      licenses: [],
      total: 0,
      currentShown: 0,
    };
  },
  created() {
    this.getLicense();
  },
  methods: {
    async getLicense() {
      try {
        this.isLoading = true;

        if (this.isError) this.resetAlert();

        const { currentShown, licenses, total, isError, errorMessage } =
          await getUserCommercialLicense();

        this.isLoading = false;
        if (isError) {
          this.setAlert(isError, errorMessage, "error");
          return;
        }

        if (!licenses.length) {
          this.setAlert(
            true,
            this.$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_EMPTY")
          );
          return;
        }

        this.licenses = licenses;
        this.currentShown = currentShown;
        this.total = total;
      } catch (error) {
        this.setAlert(true, error, "error");
        this.isLoading = false;
      }
    },
    resetAlert() {
      this.isError = false;
      this.errorMessage = "";
      this.errorType = "";
    },
    setAlert(isError, message, type = "info") {
      this.isError = isError;
      this.errorMessage = message;
      this.errorType = type;
    },
    getSerialNumberLink(serialNumber) {
      return `/license/detail/${serialNumber}/`;
    },
    getProductLink(license) {
      return `/product/${license.product.code}/?release=${license.product.version}`;
    },
    getProductText(license) {
      return `${license.product.name} ${license.product.version}`;
    },
    getNetworkType(license) {
      return license.isNetwork
        ? this.$Bitrix.Loc.getMessage(
            "USER_COMMERCIAL_LICENSE_COLUMN_NETWORK_TYPE_NETWORK"
          )
        : this.$Bitrix.Loc.getMessage(
            "USER_COMMERCIAL_LICENSE_COLUMN_NETWORK_TYPE_LOCAL"
          );
    },
    getSubscription(license) {
      return license.subscription ? license.subscription : "—";
    },
    getIsActivated(license) {
      return license.isActivated ? "Да" : "Нет";
    },
  },
  computed: {
    getShownTotal() {
      return this.$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_SHOWN_TOTAL")
        .replace("[currentShown]", this.currentShown)
        .replace("[total]", this.total);
    },
  },
  template: `
	<div class="card">
		<div class="card-header">
			<div class="row">
				<div class="col">
					<h4 class="mb-0">{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_WIDGET_TITLE")}}</h4>
				</div>
			</div>
		</div>
		<div class="card-body position-relative">
			<div class="text-center available-license__spinner" v-if="isLoading">
					<div class="spinner-border spinner-border-big" role="status"></div>
			</div>
			<div class="user-commercial__license-wrapper overflow-auto" v-if="!isError && licenses.length">
				<table class="table table-striped w-100 user-commercial__license-table">
					<thead>
            <tr>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_1")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_2")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_3")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_4")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_5")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_6")}}</th>
              <th>{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_TABLE_TH_7")}}</th>
            </tr>
					</thead>
					<tbody>
						<tr v-for="currentLicense in licenses">
							<td class="white-space-nowrap">
								<a 
									class="text-decoration-none" 
									:href="getSerialNumberLink(currentLicense.license.serialNumber)">
									{{currentLicense.license.serialNumber}}
								</a>
                <i v-if="currentLicense.license.isLinuxVersion" class="align-middle fab fa-fw fa-linux user-select-none" title="Linux версия"></i>
							</td>
							<td>
								<a :href="getProductLink(currentLicense.license)" class="text-decoration-none">{{getProductText(currentLicense.license)}}</a>
							</td>
							<td>
								{{getNetworkType(currentLicense.license)}}
							</td>
							<td v-html="currentLicense.license.dateActiveTo"></td>
							<td class="text-center" v-html="getSubscription(currentLicense.license)"></td>
							<td>
								{{currentLicense.license.quantity}}
							</td>
							<td>
								{{getIsActivated(currentLicense)}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<Alert v-if="!isLoading && isError" :alertMessage="errorMessage" :alertType="errorType" />
			<div 
				class="align-items-md-center d-flex justify-content-between user-commercial__license-bottom mt-3" v-if="!isLoading && licenses.length && !isError">
				<div>
					{{getShownTotal}}
				</div>
				<a href="/license/list/" class="btn btn-primary ms-md-3 mt-md-0 mt-2">
					{{$Bitrix.Loc.getMessage("USER_COMMERCIAL_LICENSE_PAGE_LINK_TITLE")}}
				</a>
			</div>
		</div>
	</div>
	`,
};
